import {getTranslateCheetah} from './../services/translate';

let _translations;

class Translate {
  constructor() {
    this.translations = {};
    this.i18n = this.$i18n;
    this.lang = '';
  }

  setTranslations(value) {
    this.translations = value;
  }

  getTranslations() {
    return this.translations;
  }

  seti18n(value) {
    this.i18n = value;
  }

  setLang(value) {
    this.lang = value;
    this.$lang = value;
    this.updateClass(value);
  }

  getDir() {
    if (window.getCookie('languageEditorUser') &&
      ['he_IL', 'ar_AR'].includes(window.getCookie('languageEditorUser'))
    ) {
      return 'rtl';
    } else return false;
  }

  updateClass(value) {
    let html = document.querySelector('html');
    if (value === 'he_IL' || value === 'ar_AR') {
      html.setAttribute('dir', 'rtl');
    } else {
      html.removeAttribute('dir');
    }
  }

  init(language = 'en_US', callback) {

    if (window.getCookie('languageEditorUser') == null || window.getCookie('languageEditorUser') !== language) {
      window.setCookie('languageEditorUser', language);
      window.location.reload(true);
    }

    window.setCookie('languageEditorUser', language);

    // getTranslateCheetah(language)
    //   .then(response => {
    //     if (window.editorTranslate && window.editorTranslate['en_US']) {
    //       _translations = {
    //         ...window.editorTranslate['en_US'],
    //         ...response.data.data
    //       };
    //     } else _translations = response.data.data;
    //
    //     this.translations = response.data.data;
    //
    //     this.i18n.setLocaleMessage(this.lang, _translations);
    //
    //     this.i18n.locale = this.lang;
    //
    //     if (typeof callback === 'function') {
    //       callback(response.data);
    //     }
    //   })
    //   .catch(error => {
    //     console.error(error);
    //   });
    this.i18n.locale = this.lang;
  }

  get(key, isEmpty = '') {
    var self = this.$translate;

    if (typeof self === 'undefined') {
      return;
    }

    if (typeof _translations === 'undefined') {
      setTimeout(function () {
        self.get(key);
      }, 900);
    } else if (
      typeof _translations !== 'undefined' &&
      typeof _translations[key] !== 'undefined'
    ) {
      return _translations[key];
    } else {
      // console.log(key);
    }
    return isEmpty || key;
  }
}

export default Translate;



// WEBPACK FOOTER //
// ./src/js/base/Translate.js